import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';
import { ServiceProvider } from './classes/service-provider';

@Pipe({
  name: 'serviceProviderByTag',
})
export class ServiceProviderByTagPipe implements PipeTransform {
  transform(serviceProviders: ServiceProvider[], input: string): ServiceProvider[] {
    if (Array.isArray(serviceProviders)) {
      const response = serviceProviders.filter((serviceProvider) => {
        const data = serviceProvider.form.value;

        const tags: any[] = _.get(data, 'tags', []);

        const tagIncludedIndex = tags.length
          ? _.findIndex(tags, (tag) => tag.value.toLowerCase().includes(input.toLowerCase()))
          : false;

        if (tagIncludedIndex > -1) {
          return true;
        } else {
          return false;
        }
      });

      return response;
    } else {
      return serviceProviders;
    }
  }
}
